import React, { useEffect, useState } from "react";
import { Select } from "@mantine/core";
import { getAgreementTypesApi } from "../utilities/apis/agreements";
import { getAgreementCategoriesActive } from "../utilities/apis/agreementCategories";
import { apiWrapWithErrorWithData } from "../utilities/apiHelpers";

export const DEFAULT_AGREEMENT_TYPE_OPTIONS = [
  "Service Centres",
  "Suppliers",
  "Distributors",
  "Admin",
  "Marketing",
  "Insurance",
  "Exports",
  "Tech/Subscriptions",
  "HR",
  "Logistics",
  "B2B",
  "Miscellaneous",
];

const toSelectOptions = (items) =>
  items.map((item) => ({
    label: item.name,
    value: item.id,
  }));

const AgreementTypeFilter = ({
  value,
  onChange,
  placeholder = "Agreement type",
  style,
  searchable = false,
  ...rest
}) => {
  const [options, setOptions] = useState(
    toSelectOptions(DEFAULT_AGREEMENT_TYPE_OPTIONS),
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAgreementTypes = async () => {
      setLoading(true);
      try {
        const resp = await apiWrapWithErrorWithData(
          getAgreementCategoriesActive(),
        );
        if (Array.isArray(resp?.data)) {
          setOptions(toSelectOptions(resp.data));
        }
      } finally {
        setLoading(false);
      }
    };

    loadAgreementTypes();
  }, []);

  return (
    <Select
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      data={DEFAULT_AGREEMENT_TYPE_OPTIONS}
      clearable
      searchable={searchable}
      style={style}
      {...rest}
    />
  );
};

export default AgreementTypeFilter;
